import React from "react"
import { ArrowLeftLG, withCatalogProductContainer } from "../../normalizer"
import Product from "../../shared/Product"
import Item from "./Item"
import { Link } from "react-router-dom"
import ProductCard from "../../shared/ProductCard"
import CustomButton from "../../shared/CustomButton"

const CatalogProductItem = ({ item, client, lastSeenProducts, ...actions }) => {
  const { currency_label: currencyLabel } = client
  return (
    <div className="catalog-product-item">
      <section className="catalog-product-item__back">
        <CustomButton tight link large to="/catalog">
          <ArrowLeftLG />
          Voltar
        </CustomButton>
      </section>
      <section className="catalog-product-item__content">
        <Item item={item} actions={actions} currencyLabel={currencyLabel} />
      </section>
    </div>
  )
}

export default withCatalogProductContainer(CatalogProductItem)
